<template>
  <v-container>
<!--    <v-layout align-center justify-center>-->
<!--      <v-flex xs12 sm8 md8 lg8>-->
    <v-row dense>
<!--      time-->
      <v-col>
        <v-menu
            ref="menu"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="time"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
                <v-btn text outlined>
                  <div
                      v-if="time"
                      class="headline"
                      v-bind="attrs"
                      v-on="on">

                    <span v-if="orderTime">{{momentTime(time)}}</span>
                    <span v-else>Select time</span>
                    <!--                  {{moment(Date.now())}}-->
                  </div>
                </v-btn>
          </template>
          <v-time-picker
              v-if="menu2"
              v-model="time"
              color="primary"
              full-width
              no-title
              @click:minute="timePicked()"
          ></v-time-picker>
        </v-menu>
      </v-col>


<!--      date-->
      <v-col
          cols="12"
      >
        <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            max-width="290px"
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
              <v-btn text
                     outlined>
                <div
                    class="text-h6"
                    v-bind="attrs"
                    v-on="on"
                    v-if="date">
                  <span v-if="orderDate">{{momentDate(date)}}</span>
                  <span v-else>Select date</span>
                </div>
              </v-btn>
          </template>
          <v-date-picker
              v-model="date"
              color="primary"
              no-title
              @input="datePicked()"
              :min="minMonth"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
<!--      </v-flex>-->
<!--    </v-layout>-->
  </v-container>
</template>
<script>
import moment from 'moment';
export default {
  props: ['orderDate', 'orderTime'],
  data: () => ({
    //date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    //dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
    date: '',
    menu1: false,
    time: '',
    menu2: false
  }),
  created () {
    // console.log('order date')
    // console.log(this.orderDate)
    // console.log('order time')
    // console.log(this.orderTime)
    if (this.orderDate) {
      this.date = this.orderDate
    } else {
      this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
    }
    if (this.orderTime) {
      this.time = this.orderTime
    } else {
      this.time = moment().format('HH:mm')
    }
  },
  computed: {
    minMonth () {
      let today = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
      // console.log(today)
      return today
    },
    momentDate() {
      return (date) => {
        return moment(date).format('dddd, LL')
      }
    },
    momentTime () {
      return (time) => {
        return moment(time, "HH:mm").format('hh:mm A')
      }
    },
    moment () {
      return (date) => {
        let day = moment(date).format('ddd, MMM Do, hh:mm:ss A')
        return day
      }
    }
  },
  methods: {
    datePicked () {
      // console.log(this.date)
      //let date = this.formatDate(this.date)
      this.menu1 = false
      this.$emit('dateFound', this.date)
    },
    timePicked () {
      this.menu2 = false
      this.$refs.menu.save(this.time)
      this.$emit('timeFound', this.time)
    }
  },
}
</script>
